import {isLeadContactEnrichmentPayload, normalizeLeadDerivedColumns} from './EnrichmentGrid.helpers';

/** `lead_outcome` v1 values (BE lead-finder reliability contract). A lead row's `status: "done"` is not success. */
export const LEAD_OUTCOME = Object.freeze({
  VERIFIED: 'verified_lead_found',
  NO_VERIFIED_LEAD: 'no_verified_lead',
  PROVIDER_OUTAGE: 'provider_outage',
});

export const formatLeadContacts = (derivedColumns) => normalizeLeadDerivedColumns(derivedColumns)
  .map(({name, values}) => `${name}: ${values.join(', ')}`)
  .join('\n');

export const isLeadRun = (payload) => Boolean(payload?.lead_outcome) || isLeadContactEnrichmentPayload(payload);

const creditCount = (count) => `${count} ${count === 1 ? 'credit' : 'credits'}`;

// Charge knowledge comes from lead_outcome, else from /execute charged_units. Legacy batch rows carry neither.
function chargeStatement(leadOutcome, chargedUnits) {
  if (leadOutcome) {
    return leadOutcome.charged ? ` — charged ${creditCount(Number(leadOutcome.credits_charged) || 0)}` : ' — not charged';
  }
  if (typeof chargedUnits !== 'number' || !Number.isFinite(chargedUnits)) return null;
  return chargedUnits > 0 ? ` — charged ${creditCount(chargedUnits)}` : ' — not charged';
}

/**
 * The single place a lead-finder row is classified, on the batch and single paths.
 * Returns an entry in the grid's closed status set: success, failed or missing.
 */
export function classifyLeadRow({leadOutcome = null, derivedColumns, chargedUnits} = {}) {
  const contacts = formatLeadContacts(derivedColumns);
  const outcome = leadOutcome?.outcome;
  if (outcome === LEAD_OUTCOME.VERIFIED || (!outcome && contacts)) {
    return {status: 'success', result: contacts || 'Verified lead found', title: 'Lead contacts'};
  }
  const charge = chargeStatement(leadOutcome, chargedUnits);
  if (outcome === LEAD_OUTCOME.PROVIDER_OUTAGE) {
    return {status: 'failed', error: `Lead search unavailable${charge}. Try again.`, title: 'Lead search unavailable'};
  }
  return {status: 'missing', result: '', error: charge ? `No verified lead${charge}` : 'No verified lead found', title: 'No verified lead'};
}
